/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateEvent = /* GraphQL */ `
  subscription OnCreateEvent {
    onCreateEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateEvent = /* GraphQL */ `
  subscription OnUpdateEvent {
    onUpdateEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteEvent = /* GraphQL */ `
  subscription OnDeleteEvent {
    onDeleteEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const onCreateExternalEvent = /* GraphQL */ `
  subscription OnCreateExternalEvent {
    onCreateExternalEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const onUpdateExternalEvent = /* GraphQL */ `
  subscription OnUpdateExternalEvent {
    onUpdateExternalEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
export const onDeleteExternalEvent = /* GraphQL */ `
  subscription OnDeleteExternalEvent {
    onDeleteExternalEvent {
      id
      valid_from
      valid_to
      user_id
      user_email
      arena_number
      title
      createdAt
      updatedAt
    }
  }
`;
